import type { ChangeEvent } from 'react';
import { TextInput } from '@pixum/web-input';
import type { AddressFormData } from '../../types';

interface AddressDetailsFieldsProps {
  formData: AddressFormData;
  company: boolean;
  constants: Record<string, string>;
  fieldError: (name: string) => string | undefined;
  fieldName: (name: string) => string;
  formId?: string;
  onInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  pickupPoint: boolean;
}

export function AddressDetailsFields({
  formData,
  company,
  constants,
  fieldError,
  fieldName,
  formId,
  onInputChange,
  pickupPoint
}: AddressDetailsFieldsProps) {
  return (
    <>
      {!pickupPoint && (
        <TextInput
          label={constants['i18n_street']}
          form={formId}
          name={fieldName('street')}
          value={formData.street}
          onChange={onInputChange}
          hasError={Boolean(fieldError('street') || fieldError('houseNumber'))}
          inputInfo={fieldError('street') ?? fieldError('houseNumber')}
        />
      )}
      {!pickupPoint && !company && (
        <TextInput
          label={constants['i18n_addition_to_address']}
          form={formId}
          name={fieldName('streetAddOn')}
          placeholder={constants['i18n_example_house_floor']}
          required={false}
          value={formData.streetAddOn}
          onChange={onInputChange}
          hasError={Boolean(fieldError('streetAddOn'))}
          inputInfo={fieldError('streetAddOn')}
          additionalLabelInfo={constants['i18n_optional']}
        />
      )}
      {company && !pickupPoint && (
        <TextInput
          autoComplete="off"
          label={constants['i18n_vat_reg_no']}
          form={formId}
          name={fieldName('salesTaxId')}
          required={false}
          value={formData.salesTaxId}
          onChange={onInputChange}
          hasError={Boolean(fieldError('salesTaxId'))}
          inputInfo={fieldError('salesTaxId')}
          additionalLabelInfo={constants['i18n_optional']}
        />
      )}
    </>
  );
}
